import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';


@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  notificationUpdated = new Subject<any>();

  constructor(private http: HttpClient) {}

  refreshNotification() {
    const url = `${environment.baseUrlAerolounge}/admin/v1/support/get-if-to-notify`;

    this.http.get(url).subscribe((res: any) => {
      if (res.status_code === 200) {
        this.notificationUpdated.next(res.data);
      }
    });
  }
}
